module.exports = __webpack_public_path__ + "files/979c9926f886106a9096987a5436a029.svg";